
 import { authenticatedFetch } from "../Auth/Auth";
 import { getCurrentConfig } from '../../config/config';
 
 const config = getCurrentConfig();

export const addAction = async (actionJSONbody) => {
   
    let jsonBody = {
      dateDue: actionJSONbody.dateDue,
      details: actionJSONbody.details
    }
  
    const response = await authenticatedFetch(`${config.API_BASE_URL}/actions/`, {
        method: 'POST',
        headers: {
        
          'Content-Type': 'application/json',
          'User-Agent': 'agentApp/1.0',
        },
        body: JSON.stringify(actionJSONbody)
      });
      
      if (response.ok) {
        const responseData = await response.json();
        return responseData; 
      } else {
        throw new Error(`Error updating action`);
      }
  
  };